let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hu0uQ")).then(() => parcelRequire('5m93C'));